export default "__VITE_ASSET__2603a661__"